import { ref } from 'vue';
import type { DocumentRevision } from '@/entities/Document';

export interface SgqSelectedDocument {
  documentRevisionId: number;
  prefix: string;
  title: string;
  revision: number;
}

function mapSelectedDocument(documentRevision: DocumentRevision): SgqSelectedDocument {
  return {
    documentRevisionId: documentRevision.id,
    prefix: documentRevision.document.prefix,
    title: documentRevision.document.name,
    revision: documentRevision.revision,
  };
}

export function useSgqDocumentSelection() {
  const isModalOpen = ref(false);
  const selectedDocument = ref<SgqSelectedDocument | null>(null);

  function openModal(): void {
    isModalOpen.value = true;
  }

  function closeModal(): void {
    isModalOpen.value = false;
  }

  function handleDocumentSelected(documentRevision: DocumentRevision): void {
    selectedDocument.value = mapSelectedDocument(documentRevision);
    closeModal();
  }

  function removeSelectedDocument(): void {
    selectedDocument.value = null;
  }

  return {
    isModalOpen,
    selectedDocument,
    openModal,
    closeModal,
    handleDocumentSelected,
    removeSelectedDocument,
  };
}
